import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useEnterExitAnimation } from '../../../util/useEnterExitAnimation.js';

var _excluded = ["state", "aria-label", "aria-labelledby"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useLoadingContainer = function useLoadingContainer(_ref) {
  var state = _ref.state,
    ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  // Aria attributes for loading state
  var loadingAttributes = _objectSpread({
    role: 'alert',
    'aria-live': ariaLabel || ariaLabelledBy ? 'assertive' : undefined,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy
  }, rest);
  var animation = {
    initialProps: {
      opacity: 0
    },
    enterProps: {
      opacity: 1
    }
  };

  // Handle fade out loading container
  var _useEnterExitAnimatio = useEnterExitAnimation(_objectSpread(_objectSpread({}, animation), {}, {
      animationOn: state === 'loading',
      transition: '600ms ease-out'
    })),
    loadingTransitionProps = _useEnterExitAnimatio.transitionProps,
    shouldRenderLoading = _useEnterExitAnimatio.shouldRender;

  // Handle fade in loaded content
  var _useEnterExitAnimatio2 = useEnterExitAnimation(_objectSpread(_objectSpread({}, animation), {}, {
      animationOn: state === 'loaded',
      transition: '600ms ease-in'
    })),
    loadedTransitionProps = _useEnterExitAnimatio2.transitionProps,
    shouldRenderLoaded = _useEnterExitAnimatio2.shouldRender;
  return {
    loadingProps: _objectSpread(_objectSpread({}, loadingAttributes), loadingTransitionProps),
    shouldRenderLoading: shouldRenderLoading,
    loadedProps: _objectSpread(_objectSpread({}, rest), loadedTransitionProps),
    shouldRenderLoaded: shouldRenderLoaded
  };
};

export { useLoadingContainer };
//# sourceMappingURL=useLoadingContainer.js.map
